@if (
  {
    isMovingItemLeftRight:
      dragAndDropModeService.isMovingItemLeftRight$ | async,
    horizontalDemarcatorRange:
      dragAndDropModeService.horizontalDemarcatorRange$ | async,
    showDuration: dragAndDropModeService.showDuration$ | async,
    frameLength: frameLength$ | async,
  };
  as data
) {
  @if (
    data.isMovingItemLeftRight &&
    data.horizontalDemarcatorRange?.left &&
    data.horizontalDemarcatorRange?.right
  ) {
    @if (
      {
        leftPx:
          (data.horizontalDemarcatorRange?.left ?? 0) +
          resourcesColumnWidthPx -
          LEFT_TAG_POSITION_MODIFIER,
        rightPx:
          (data.horizontalDemarcatorRange?.right ?? 0) -
          RIGHT_TAG_POSITION_MODIFIER,
        pxSum:
          (data.horizontalDemarcatorRange?.right ?? 0) +
          (data.horizontalDemarcatorRange?.left ?? 0),
      };
      as computedDuration
    ) {
      <div>
        <div class="drop-zone" [style.left.px]="computedDuration.leftPx">
          <nz-tag nzColor="default">
            {{
              dragAndDropModeService.draggingItemStartDatetime$
                | async
                | date: DateTimeFormat.TimeFormat
            }}
          </nz-tag>
        </div>
        @if (data.showDuration) {
          @if (
            {
              durationLeft:
                ((data.frameLength ?? 0) - computedDuration.pxSum) / 2 +
                computedDuration.leftPx,
            };
            as durationCalculation
          ) {
            <div
              class="duration"
              [style.left.px]="durationCalculation.durationLeft + 30"
            >
              {{
                (data.horizontalDemarcatorRange?.shiftDuration ?? 0) / 3600000
                  | hoursToHoursMinutes
              }}
            </div>
          }
        }
        <div class="drop-zone" [style.right.px]="computedDuration.rightPx">
          <nz-tag nzColor="default">
            {{
              dragAndDropModeService.draggingItemEndDatetime$
                | async
                | date: DateTimeFormat.TimeFormat
            }}
          </nz-tag>
        </div>
      </div>
    }
  }
}
